export default {
  configuracoes: {
    limite_dias_inadimplente: 0,
    dias_antecedencia: 0,
    dias_vencimento: 3,
    teto_caracteres_traducao: null,
  },
  is_loading: false,
};
